import {
	Serializer,
	UISerializableOrderActionRecord,
} from '@velocity-exchange/common';
import { getTradesHistoryFilter } from 'src/utils/historyTables';
import { useComposedHistory } from './useComposedHistory';
import type { HistoryTableUIProps } from './historyDataTypes';

export const useTradesHistory =
	(): HistoryTableUIProps<UISerializableOrderActionRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'trades',
			Serializer.Deserialize.DataApiUIOrderActionRecord
		);

		return { executePageChange, filterFn: getTradesHistoryFilter, historyData };
	};
